import React from 'react';
import { HelperLine as HelperWrapper, HelperText, ErrorMessage } from '../field';

var HelperSection = function HelperSection(_ref) {
  var name = _ref.name,
      errors = _ref.errors,
      fieldOptions = _ref.fieldOptions;
  var showHelperText = !!fieldOptions && fieldOptions.helperText && errors && !errors[name];
  return React.createElement(HelperWrapper, null, errors && errors[name] && React.createElement(ErrorMessage, null, errors[name].message), showHelperText && React.createElement(HelperText, null, fieldOptions === null || fieldOptions === void 0 ? void 0 : fieldOptions.helperText));
};

export default HelperSection;